import { IdeaProgress, IdeaStatus } from "../api/psc";

export const ForumStatusList = [
    {
        id: IdeaStatus.PENDING,
        title: "در انتظار بررسی ادمین",
        color: "#c28e00",
    },
    { id: IdeaStatus.ACCEPTED, title: "تایید شده", color: "#0b8a5b" },
    { id: IdeaStatus.REJECTED, title: "رد شده", color: "#9e2433" },
];

export const ForumProgressList = [
    { id: IdeaProgress.PENDING, title: "در انتظار", color: "#007efc" },
    { id: IdeaProgress.IN_PROGRESS, title: "در حال انجام", color: "#00ad85" },
    { id: IdeaProgress.DONE, title: "انجام شده", color: "#198a46" },
    {
        id: IdeaProgress.NOT_FEASIBLE,
        title: "غیر قابل انجام",
        color: "#682cde",
    },
];
